<mobile-header-component></mobile-header-component>
<div class="_home-mobile-page">
    <div class="_intro">
        <p>
            <b>{{ 'MOBILE_VIEW.HOME.TITLE' | translate }} {{userDetails?.digibank}}</b>
        </p> 

        <img src="./assets/imgs/icon_app_x2.png" alt="">
        <p>
            {{ 'MOBILE_VIEW.HOME.INTRO1' | translate }}
        </p>
        <p>
            {{ 'MOBILE_VIEW.HOME.INTRO2' | translate }}
        </p>
    </div>
    <div class="_buttons">
        <button type="button" class="_button" (click)="goToEvents()">
            {{ 'MOBILE_VIEW.HOME.GET_STARTED' | translate }}
        </button>
    </div>
</div>
